import React from 'react'
import { withRouter } from 'react-router-dom'
import ReduxToastr from 'react-redux-toastr'
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles'
import red from 'material-ui/colors/red'
import 'typeface-fira-sans'
import 'font-awesome/less/font-awesome.less'
import 'react-redux-toastr/src/styles/index.scss'
import 'bootstrap/dist/css/bootstrap.css'

import withRef from '../hocs/ref'
import Loading from '../layouts/loading'
import Public from '../routes/public'
import Private from '../routes/private'
import Anonymous from '../routes/anonymous'
import Dashboard from '../pages/dashboard'
// import Close from '../pages/close'
import Kyc from '../pages/users/kyc'
import Deposits from '../pages/deposits'
import Tokens from '../pages/tokens'
import Distribution from '../pages/distribution'
import ProfileEdit from '../pages/profile/edit'
import ProfilePayments from '../pages/profile/payments'
import SignIn from '../pages/users/sign_in'
import SignUp from '../pages/users/sign_up'
import RemindPassword from '../pages/users/password/new'
import EditPassword from '../pages/users/password/edit'
import Confirmation from '../pages/users/confirmation'
import Unlock from '../pages/users/unlock'
import '../../table'
import '../../assets/stylesheets/styles.less'

const shpingColor = {
  ...red,
  500: '#EF3D47'
}

const theme = createMuiTheme({
  palette: {
    primary: shpingColor
  },
  typography: {
    fontFamily: 'Fira Sans'
  },
  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
      xs: 1,
      sm: 768,
      md: 990,
      lg: 1280,
      xl: 1920
    }
  },
  overrides: {
    MuiTableCell: {
      paddingDefault: {
        padding: '8px'
      }
    },
    MuiDialogTitle: {
      root: {
        'text-align': 'center'
      }
    },
    MuiButton: {
      root: {
        'font-size': '0.75rem'
      },
      dense: {
        'border-radius': '0.3rem !important',
        'text-transform': 'none'
      },
      raised: {
        'border-radius': '1.2rem',
        'box-shadow': 'none'
      }
    },
    MuiPaper: {
      rounded: {
        'border-radius': '1.2rem'
      }
    }
  }
})

const Routes = withRouter(
  withRef(() => (
    <React.Fragment>
      <ReduxToastr
        timeOut={5000}
        newestOnTop={false}
        preventDuplicates={false}
        position="top-right"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
      />
      <Private exact path="/" component={Dashboard} />
      <Public exact path="/close-ico" component={Dashboard} />
      <Private exact path="/verification" component={Kyc} />
      <Private exact path="/deposits" component={Deposits} />
      <Private exact path="/tokens" component={Tokens} />
      <Private exact path="/distribution" component={Distribution} />
      <Private exact path="/profile/edit" component={ProfileEdit} />
      <Private exact path="/profile/payments" component={ProfilePayments} />
      <Anonymous exact path="/users/sign_in" component={SignIn} />
      <Anonymous exact path="/users/sign_up" component={SignUp} />
      <Anonymous exact path="/users/password/new" component={RemindPassword} />
      <Anonymous exact path="/users/password/edit" component={EditPassword} />
      <Anonymous exact path="/users/confirmation" component={Confirmation} />
      <Anonymous exact path="/users/unlock" component={Unlock} />
    </React.Fragment>
  ))
)

export default () => (
  <MuiThemeProvider theme={theme}>
    <Loading>
      <Routes />
    </Loading>
  </MuiThemeProvider>
)



// WEBPACK FOOTER //
// ./src/containers/app/index.js